import { useTranslation } from 'react-i18next';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

// Import context
import { useMainPacketContext } from 'components/context/main_packet/MainPacketProvider';

export const MainPacketButton = () => {
	const { t } = useTranslation('configurator');
	const { isPricesLoading, isSelected, isSubscriptionModification, onSelect } = useMainPacketContext();

	if (isSelected) {
		return (
			<Button disabled variant="secondary" modifiers={['outlined']}>
				{t('button_current_selected')}
			</Button>
		);
	}

	if (isSubscriptionModification) {
		return (
			<Button onClick={onSelect} disabled={isPricesLoading} variant="primary" modifiers={['contained']}>
				{t('button_packet_change')}
			</Button>
		);
	}

	return (
		<Button onClick={onSelect} disabled={isPricesLoading} variant="primary" modifiers={['contained']}>
			{t('button_select')}
		</Button>
	);
};
